// extracted by mini-css-extract-plugin
export default {"event-details":"style_event-details__BugGl","content":"style_content__if2mH","info":"style_info__q3-P6","modal-wrapper":"style_modal-wrapper__9BUCi"};